import { createSlice } from '@reduxjs/toolkit';
import type { PayloadAction } from '@reduxjs/toolkit';
import omit from 'lodash/omit';
import { tenantScopeReset } from '../Organizations/OrganizationsSlice/tenantScopeReset';
import type { RootState } from '../../store';

type ChatDraftsState = Record<
  string,
  {
    text: string;
    replyId?: number;
    editId?: number;
  }
>;

const chatDraftsSlice = createSlice({
  name: 'chatDrafts',
  initialState: {} as ChatDraftsState,
  reducers: {
    setChatDraft(
      state,
      action: PayloadAction<{
        chatId: string;
        draft: {
          text: string;
          replyId?: number;
          editId?: number;
        };
      }>
    ) {
      const { chatId, draft } = action.payload;
      if (!draft.text?.trim() && !draft.replyId && !draft.editId) {
        return omit(state, chatId);
      }
      return { ...state, [chatId]: draft };
    },
    clearChatDraft(state, action: PayloadAction<string>) {
      const chatId = action.payload;
      return omit(state, chatId);
    },
    clearAllChatDrafts() {
      return {};
    },
  },
  extraReducers: builder => {
    builder.addCase(tenantScopeReset, () => ({}));
  },
});

export const { setChatDraft, clearChatDraft, clearAllChatDrafts } = chatDraftsSlice.actions;

export const selectDraft = (chatId: string) => (state: RootState) =>
  state.chatDrafts[chatId] ?? null;

export const selectAllDrafts = (state: RootState) => state.chatDrafts;

export default chatDraftsSlice.reducer;
